import React from "react";
import { motion } from "framer-motion";
import SectionHeading from "./SectionHeading";
import Reveal, { staggerContainer, staggerItem } from "./Reveal";
import { skillGroups } from "../data/content";
import { useLanguage } from "../context/LanguageContext";

export default function Skills() {
    const { t } = useLanguage();

    return (
        <section id="skills" className="section section--alt">
            <div className="section__inner">
                <SectionHeading eyebrow={t.skills.eyebrow} title={t.skills.title} />

                <div className="skills">
                    {skillGroups.map((group, gi) => (
                        <Reveal key={group.id} delay={gi * 0.08} className="skills__group">
                            <h3 className="skills__group-title">{t.skills.groups[group.id]}</h3>
                            <motion.div
                                className="skills__grid"
                                variants={staggerContainer}
                                initial="hidden"
                                whileInView="show"
                                viewport={{ once: true, amount: 0.2 }}
                            >
                                {group.items.map((skill) => {
                                    const Icon = skill.icon;
                                    return (
                                        <motion.div
                                            className="skill-card"
                                            key={skill.name}
                                            variants={staggerItem}
                                            whileHover={{ y: -6 }}
                                        >
                                            <span className="skill-card__icon">
                                                <Icon />
                                            </span>
                                            <span className="skill-card__name">{skill.name}</span>
                                        </motion.div>
                                    );
                                })}
                            </motion.div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
